import { Component, OnInit, Inject, Optional } from '@angular/core';
import { PershingTranslationService, PermissionCheckerService, AppDataStore } from '@pershing/pershing-core';
import moment from 'moment-timezone';
import { PortalComponentService } from '../../services/portal-component.service';
import { Location } from '@angular/common';


@Component({
  selector: 'profile-menu',
  templateUrl: './profile-menu.component.html'
})
export class ProfileMenuComponent implements OnInit {
  isLogoutDisabled: boolean = false;
  hideLastLoginTime: boolean;
  displaySettingEntitlement: boolean = false;
  isSpanishEnabledIBD: boolean = false;
  showDisplaySettingsMenu: boolean = false;
  isSSOLogoutHide: boolean = false;
  date: any;
  time: any;
  isSSO: boolean = false;
  isModernThemeOnly: boolean = false;
  constructor(private translationService: PershingTranslationService, private location: Location, private portalComponentService: PortalComponentService,
    private authorizationService: PermissionCheckerService, @Optional() @Inject('AppSettings') appSettings: any, private appData: AppDataStore) {
    this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
    if (appSettings.ibdConfigMap.community === 'equipt' && appSettings.isVendorSso) {
      this.hideLastLoginTime = true;
    }
    this.isModernThemeOnly = appSettings.ibdConfigMap.isModernThemeOnly ? true : false;
    let spanishSiteEnabledIBDs = appSettings.ibdConfigMap.spanishSiteEnabledIBD;
    if (spanishSiteEnabledIBDs.includes(appSettings.ibdConfigMap.IBD) || (appSettings.ibdConfigMap.generic && appSettings.ibdConfigMap.community === 'netxinvestor')) {
      this.isSpanishEnabledIBD = true;
    }
    this.checkDisplaySetting();   
    if (appSettings.isVendorSso || appSettings.isAdvisor) {
      this.isSSO = true;
    }
    if (appSettings.isSSOLogoutHide) {
      this.isSSOLogoutHide = appSettings.isSSOLogoutHide;
  }

  }

  checkDisplaySetting() {
    if (this.isModernThemeOnly && !this.isSpanishEnabledIBD) {
      this.showDisplaySettingsMenu = false;
    }
    else {
      this.showDisplaySettingsMenu = this.authorizationService.isEntitled('DISPLAY_SETTINGS || ENABLE_NEW_THEME');
    }
  }

  ngOnInit() {
    this.getLastLogonTime();
  }

  logout(): void {
    this.isLogoutDisabled = true;
    let billsuiteOpener = this.appData.get('billsuiteOpener');
    if (billsuiteOpener) {
      billsuiteOpener.close();
    }
    document.dispatchEvent(new CustomEvent('portal.DASFLogoutEvent'));
  }


  navigateToSettings(page: any): void {
    let disclosureUrl = this.location.path();
    if (disclosureUrl.includes('disclosure')) {
      this.reloadAndNavigate(page);
    } else {
      document.dispatchEvent(new CustomEvent('portal.gotoview', {
        detail: {
          'gotoPage': page
        }
      }));
    }
  }

  reloadAndNavigate(page: any) {
    location.href = page;
  }

  getLastLogonTime(): void {
    this.portalComponentService.getLastLoginTime(' ', ' ').subscribe(
      response => {
        // this.passwordExpiryDays = response.passwordExpiryDays;
        if (response?.lastLogonTime) {
            this.date = moment(new Date(response.lastLogonTime)).format("MMM D, YYYY");
            this.time = moment(new Date(response.lastLogonTime)).format("hh:mm A");
        } else {
            this.date = moment.tz(new Date(), "America/New_York").format("MMM D, YYYY");
            this.time = moment.tz(new Date(), "America/New_York").format("hh:mm A");
        }
      }
    );
  }

}